<template>
  <div class="card-form">
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditFormDialog="openEditFormDialog"
      @checkbox-change="(rows) => (checkedRows = rows)"
    >
      <div slot="header" class="d-flex">
        <PageHeader
          ref="header"
          style="width: 100%; min-width: 250px; max-width: 600px"
          @query="getData"
          @reset="resetPage"
        />
      </div>
      <pagination
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>

    <EditForm
      :visible.sync="editFormOpts.visible"
      :type="editFormOpts.type"
      :custApprovalRequestCode="editFormOpts.custApprovalRequestCode"
      :custCode="editFormOpts.custCode"
      :custApprovalRequestType="editFormOpts.custApprovalRequestType"
      :custApprovalNode="editFormOpts.custApprovalNode"
      :title="editFormOpts.title"
      @reload="reload"
    />
  </div>
</template>

<script>
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import PageMain from './main.vue'
import PageHeader from './header.vue'
import EditForm from '../edit-form/index.vue'
export default {
  components: {
    PageMain,
    PageHeader,
    EditForm,
  },
  mixins: [BaseTable, EditLoading],
  data() {
    return {
      usePage: true,
      checkedRows: [],
      editFormOpts: { visible: false, type: '', custApprovalRequestCode: '' },
    }
  },
  computed: {
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .customerApprovalRequsetListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditFormDialog({
      type,
      row: {
        custApprovalRequestType,
        custApprovalRequestCode,
        custCode,
        custApprovalNode,
      },
    }) {
      const disabled = type === 'detail'
      const types = {
        F:
          this.$l('dialog_label_formal_customer_application') ||
          '转成正式客户申请',
        I:
          this.$l('dialog_label_basic_information_change') ||
          '基本信息变更申请',
        O:
          this.$l('dialog_label_change_of_order_information') ||
          '接单信息变更申请',
        B: this.$l('dialog_label_bank_account_change') || '银行账号变更申请',
        P:
          this.$l('dialog_label_convert_to_potential_customer') ||
          '转成潜在客户申请',
      }
      this.editFormOpts = {
        visible: true,
        title: types[custApprovalRequestType],
        custApprovalRequestCode,
        custApprovalRequestType,
        disabled,
        type,
        custCode,
        custApprovalNode,
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.vxe-button--opts {
  margin: 0 12px;
  min-width: max-content;
}
.clearable-button {
  .el-icon-circle-close {
    display: none;
  }
}
.clearable-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
